import React from 'react';
type Variant = 'primary' | 'secondary' | 'dark';
type Size = 'sm' | 'md' | 'lg';
const base = 'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-medium transition-[background-color,color,border-color,transform,box-shadow] duration-200 ease-smooth active:translate-y-[1px] disabled:opacity-60 disabled:pointer-events-none';
const variants: Record<Variant, string> = {
  primary: 'bg-accent text-white hover:bg-accent-deep shadow-[0_10px_24px_-16px_rgba(168,85,47,0.9)]',
  secondary: 'bg-white text-ink border border-line hover:border-ink/30 hover:bg-canvas',
  dark: 'bg-ink text-white hover:bg-black'
};
const sizes: Record<Size, string> = {
  sm: 'h-9 px-4 text-sm',
  md: 'h-11 px-5 text-[15px]',
  lg: 'h-14 px-7 text-base'
};
interface Common {
  variant?: Variant;
  size?: Size;
  className?: string;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...rest
}: Common & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button className={`${base} ${variants[variant]} ${sizes[size]} ${className}`} {...rest} data-id="element-213" data-mp="jozhnafy10s1">
      {children}
    </button>;
}
export function LinkButton({
  href,
  variant = 'primary',
  size = 'md',
  className = '',
  children
}: Common & {
  href: string;
}) {
  return <a href={href} className={`${base} ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-214" data-mp="on129zt0p85m">
      {children}
    </a>;
}
export function buttonClasses(variant: Variant = 'primary', size: Size = 'md', className = ''): string {
  return `${base} ${variants[variant]} ${sizes[size]} ${className}`;
}